import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DETAIL_MODAL, UPDATE_STATUS_MODAL } from '@features/invoice-management/const'
import {
  fetchInvoiceManagementList,
  fetchDetailHistory,
  createInvoiceHistory,
  fetchInvoiceManagementListForExcel
} from './asyncAction'
import { initialState } from './initState'

const invoiceManagementSlice = createSlice({
  name: 'invoiceManagement',
  initialState,
  reducers: {
    setShowModalChangeStatue (state, action) {
      state.showModalChangeStatus = action.payload
    },
    setShowModalDetail (state, action) {
      state.showModalDetail = action.payload
    },
    setLoading (state, action) {
      state.isLoading = action.payload
    },
    setTempData (state, action) {
      state.tempData.id = action.payload.invoiceId
      state.tempData.invoiceStatus = action.payload.invoiceStatus
      state.tempData.callBackModal = action.payload.modal
    },
    clearDownloadList (state) {
      state.invoiceListDownload = []
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchInvoiceManagementList.fulfilled, (
        state,
        action: PayloadAction<TInvoiceManagementDetail.TState['invoiceList']>
      ) => {
        if (!action.payload?.data) return
        state.invoiceList = action.payload
        state.isFetchingInvoiceList = false
      })
      .addCase(fetchInvoiceManagementListForExcel.fulfilled, (
        state,
        action: PayloadAction<TInvoiceManagementDetail.TState['invoiceList']>
      ) => {
        if (!action.payload?.data) return
        state.isLoading = false
        state.invoiceListDownload = action.payload.data
      })
      .addCase(fetchInvoiceManagementList.rejected, state => {
        state.isFetchingInvoiceList = true
      })
      .addCase(fetchDetailHistory.fulfilled, (
        state,
        action: PayloadAction<TInvoiceManagementDetail.TState['invoiceHistoryDetail']>
      ) => {
        if (!action.payload?.data) return
        state.invoiceHistoryDetail = action.payload
        state.isLoading = false
        if (state.tempData.callBackModal === DETAIL_MODAL) {
          state.showModalDetail = true
        } else if (state.tempData.callBackModal === UPDATE_STATUS_MODAL) {
          state.showModalChangeStatus = true
        }
      })
      .addCase(fetchDetailHistory.rejected, state => {
        state.isLoading = false
        state.showModalChangeStatus = true
      })
      .addCase(createInvoiceHistory.fulfilled, state => {
        state.showModalChangeStatus = false
        state.isLoading = false
        state.invoiceList.data.forEach(e => {
          if (e.id === state.tempData.id) {
            e.invoiceStatus = state.tempData.invoiceStatus || ''
          }
        })
        state.tempData.id = ''
        state.tempData.invoiceStatus = ''
        state.invoiceList = { ...state.invoiceList }
      })
  }
})

export * from './asyncAction'

export const {
  setShowModalChangeStatue,
  setLoading,
  setTempData,
  setShowModalDetail,
  clearDownloadList
} = invoiceManagementSlice.actions

export const invoiceManagementReducer = invoiceManagementSlice.reducer
